import {PossibleValueInput} from 'src/modules/event-create/attributes-block/typedefs';

export const updatePossibleValueInput = (
    currentValues: PossibleValueInput[],
    index: number,
    value: string,
    isEmptySlot: boolean,
): PossibleValueInput[] =>
    currentValues.map((item, itemIndex) =>
        itemIndex === index ? {value, isEmptySlot} : item);
